import React from 'react'
import compact from 'lodash/compact'
import { ContextCard } from 'transfix-ui/components/ContextCard'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Link, makeStyles } from 'transfix-ui/core'
import { ShipmentInfo } from './ShipmentInfo'
import { useOnShipmentsByShipperFacilityUuidQuery } from './graphql/OnShipmentsByShipperFacilityUuid'

export interface IOnHoldShipmentsProps {
  shipperFacilityUuid: string
  shipmentId: string
}

const useOnHoldShipmentsStyles = makeStyles(() => ({
  contextCard: {
    display: 'inline-block',
  },
}))

export const OnHoldShipments = ({ shipmentId, shipperFacilityUuid }: IOnHoldShipmentsProps) => {
  const styles = useOnHoldShipmentsStyles()
  const { data } = useOnShipmentsByShipperFacilityUuidQuery({ variables: { shipperFacilityUuid } })

  const { shipments: shipmentsData } = data || {}
  const { nodes: shipments } = shipmentsData || {}

  const computedShipments = compact(shipments).filter(({ id }) => id !== shipmentId)
  const totalCount = computedShipments.length
  const hasShipmentId = Boolean(shipmentId)

  if (totalCount < 1) return null

  return (
    <InlineMessage
      type={INLINE_MESSAGE_VARIANTS.WARNING}
      message={
        <span>
          The facility received via EDI is currently being used with{' '}
          <ContextCard
            parentClassName={styles.contextCard}
            triggerText={
              <Link>
                {totalCount} {hasShipmentId ? 'other ' : ''}shipment{totalCount === 1 ? '' : 's'}
              </Link>
            }>
            <div>
              {computedShipments.map(shipment => (
                <ShipmentInfo
                  key={shipment.id}
                  shipmentId={shipment.id}
                  shipperName={shipment.shipperApplication.name}
                  stops={shipment.stops}
                />
              ))}
            </div>
          </ContextCard>{' '}
          that are <b>On Hold</b>. Any changes made here will also be applied to all other
          shipments.
        </span>
      }
    />
  )
}
